import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CalendarFiltersState {
  filtersVisible: boolean;
  setFiltersVisible: (visible: boolean) => void;
  toggleFiltersVisible: () => void;
}

export const useCalendarFiltersStore = create<CalendarFiltersState>()(
  persist(
    (set) => ({
      filtersVisible: false,
      setFiltersVisible: (visible) => set({ filtersVisible: visible }),
      toggleFiltersVisible: () =>
        set((state) => ({ filtersVisible: !state.filtersVisible })),
    }),
    {
      name: 'staff-portal-calendar-filters',
      partialize: (state) => ({ filtersVisible: state.filtersVisible }),
    }
  )
);
